// File: src/App.js
import React, { useEffect, useState, useCallback } from "react";
import "./App.css";
// Ensure these files exist in your project structure
import { Filters, ResultsTable } from "./Filters";
import ReportsPage from "./ReportsPage";
import MasterReport from "./MasterReport"; 
import Dashboard from "./Dashboard"; 

import API from "./config";

// const API = process.env.REACT_APP_API_URL || "http://localhost:5000";

/* ---------------------------------------------------------
   ROBUST FETCH WRAPPER WITH SESSION HANDLING
--------------------------------------------------------- */
const fetchJSON = async (url, opts = {}) => {
  opts.credentials = "omit";
  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), 15000); // 15 seconds
  opts.signal = controller.signal;

  try {
    const res = await fetch(url, opts);
    clearTimeout(id);

    // --- SESSION EXPIRY CHECK ---
    if (res.status === 401) {
      // Dispatch a custom event that App.js listens for
      window.dispatchEvent(new CustomEvent("auth:session-expired"));
      return { 
        ok: false, 
        status: 401, 
        data: { error: "Session expired. Please login again." } 
      };
    }
    // ----------------------------

    const txt = await res.text();
    try {
      return { ok: res.ok, status: res.status, data: JSON.parse(txt) };
    } catch {
      return { ok: res.ok, status: res.status, data: txt };
    }
  } catch (err) {
    clearTimeout(id);
    console.error("Fetch Error:", err);
    return {
      ok: false,
      status: 504,
      data: { error: "Server Timeout: Took too long to respond." },
    };
  }
};

/* ------------------------- Login (Govt Standard) ------------------------ */
function Login({ onLogin, serverStatus, checkingServer }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setLoading(true);
    const res = await fetchJSON(`${API}/api/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ Email: email, Password: password }),
    });
    setLoading(false);
    if (!res.ok) {
      alert(res.data.error || "Login failed. Check server connection.");
      return;
    }
    onLogin(res.data.token, res.data.user);
  }

  const loginButtonLabel = loading
    ? serverStatus === "online" ? "Verifying Credentials..." : "Connecting..."
    : "Secure Login";

  return (
    <div className="login-root" style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      {/* 1. Official Header Strip */}
      <header style={{ background: "#fff", borderBottom: "5px solid #FF9933", padding: "15px 0" }}>
        <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 20px", display: "flex", alignItems: "center", justifyContent: "center", flexWrap: "wrap", gap: "20px" }}>
          <img
            src="https://ik.imagekit.io/nanoplex/Project%20Image/NSFDC/nsfdclogo-removebg-preview_aCQYROM-P.png?updatedAt=1763554348489"
            alt="NSFDC Logo"
            style={{ height: "90px", objectFit: "contain" }}
          />
          <div style={{ textAlign: "center" }}>
            <h1 style={{ fontSize: "1.4rem", color: "#094978", margin: "0", fontWeight: "800", textTransform: "uppercase" }}>
              National Scheduled Castes Finance and Development Corporation
            </h1>
           
            <p style={{ margin: "2px 0 0", color: "#138808", fontSize: "1.0rem", fontWeight: "600" }}>
              (A Govt. of India Undertaking) - Ministry of Social Justice and Empowerment
            </p>

              <h1 style={{ fontSize: "1.3rem", color: "#094978", marginTop: "12px", fontWeight: "700", textTransform: "uppercase" }}>
              National Fellowship for SC Students Scheme (NFSC)
            </h1>
          </div>
        </div>
      </header>

      {/* 2. Login Area */}
      <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", padding: "40px 20px" }}>
        <div className="login-card" style={{ background: "#fff", padding: "40px", width: "100%", maxWidth: "450px" }}>
          <div style={{ textAlign: "center", marginBottom: "25px" }}>
            <h2 style={{ color: "#094978", margin: "0 0 10px", fontSize: "1.6rem" }}>PMS Portal</h2>
            <div style={{ height: "4px", width: "50px", background: "#FF9933", margin: "0 auto" }}></div>
            <p className="muted" style={{ marginTop: "10px" }}>Restricted Access • Authorized Personnel Only</p>
          </div>

          <div style={{ textAlign: "center", marginBottom: "20px", fontSize: "0.85rem", fontWeight: "600", color: serverStatus === "online" ? "#138808" : "#d32f2f" }}>
           {/* {checkingServer ? "Establishing secure connection..." : serverStatus === "online" ? "● Server Online" : "● Server Offline"} */} 
          </div>

          <form onSubmit={submit} className="login-form">
            <div className="login-field" style={{ marginBottom: "20px" }}>
              <label style={{ display: "block", marginBottom: "6px", fontWeight: "600", color: "#333" }}>Username / Email</label>
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="official@nsfdc.nic.in" required style={{ width: "100%", padding: "12px" }} />
            </div>

            <div className="login-field" style={{ marginBottom: "25px" }}>
              <label style={{ display: "block", marginBottom: "6px", fontWeight: "600", color: "#333" }}>Password</label>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" required style={{ width: "100%", padding: "12px" }} />
            </div>

            <button className="btn login-btn" disabled={loading} style={{ width: "100%", padding: "14px", color: "white", fontSize: "1rem" }}>
              {loginButtonLabel}
            </button>

            {loading && (
               <div style={{ marginTop: "16px" }}>
                  <div style={{ height: "4px", background: "#eee", overflow: "hidden" }}>
                    <div style={{ width: "50%", height: "100%", background: "#094978", animation: "indeterminate 1s infinite linear" }}></div>
                  </div>
                  <p style={{ textAlign: "center", fontSize: "12px", marginTop: "5px" }}>Verifying via NSFDC Server...</p>
               </div>
            )}
          </form>
        </div>
      </div>

      {/* 3. Footer */}
      <footer style={{ backgroundColor: "#222", color: "#aaa", padding: "15px", textAlign: "center", fontSize: "0.8rem" }}>
        <p style={{ margin: 0 }}>© {new Date().getFullYear()} NSFDC. All Rights Reserved. Payment Monitoring System </p>
      </footer>
    </div>
  );
}

/* ------------------------- Sidebar ---------------------- */
function Sidebar({ collapsed, setCollapsed, active, setActive, serverStatus }) {
  const handleNavClick = (page) => {
    setActive(page);
    if (window.innerWidth <= 720) {
      setCollapsed(false); 
    }
  };

  const statusColor = serverStatus === "online" ? "#2ecc71" : serverStatus === "offline" ? "#e74c3c" : "#f1c40f";

  return (
    <aside className={`sidebar ${collapsed ? "collapsed" : ""}`}>
      <div className="sidebar-top">
        <div className="logo">{collapsed ? "PMS" : "PMS PORTAL"}</div>
      </div>

      <nav className="nav">
        {/* --- NEW DASHBOARD ITEM --- */}
        <button 
          className={`nav-item ${active === "dashboard" ? "active" : ""}`} 
          onClick={() => handleNavClick("dashboard")}
        >
          <span className="material-icons icon">dashboard</span>
          {!collapsed && <span className="nav-label">Dashboard</span>}
        </button>

        {/* Filter & Search */}
        <button 
          className={`nav-item ${active === "filter_search" ? "active" : ""}`} 
          onClick={() => handleNavClick("filter_search")}
        >
          <span className="material-icons icon">manage_search</span>
          {!collapsed && <span className="nav-label">Filter & Search</span>}
        </button>

        {/* Reports */}
        <button 
          className={`nav-item ${active === "reports" ? "active" : ""}`} 
          onClick={() => handleNavClick("reports")}
        >
          <span className="material-icons icon">assessment</span>
          {!collapsed && <span className="nav-label">Reports</span>}
        </button>

        {/* Master Report */}
        <button 
          className={`nav-item ${active === "master_report" ? "active" : ""}`} 
          onClick={() => handleNavClick("master_report")}
        >
          <span className="material-icons icon">library_books</span>
          {!collapsed && <span className="nav-label">Master Report</span>}
        </button>

  
     
      </nav>

      <div className="sidebar-foot">
        {!collapsed ? (
          <div>
            <div style={{ fontWeight: "bold", color: "#fff", marginBottom: "4px" }}>System Status</div>
            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <span style={{ width: 8, height: 8, borderRadius: "50%", background: statusColor }} />
              <span>{serverStatus === "online" ? "Connected" : "Offline"}</span>
            </div>
            <div style={{ marginTop: "8px", fontSize: "10px", opacity: 0.7 }}>v1.0 </div>
          </div>
        ) : (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <span style={{ width: 8, height: 8, borderRadius: "50%", background: statusColor }} />
          </div>
        )}
      </div>
    </aside>
  );
}

/* ------------------------- Topbar ----------------------- */
function Topbar({ title, user, onLogout, onToggle }) {
  return (
    <header className="topbar">
      <div style={{ display: "flex", alignItems: "center" }}>
        <button className="icon-btn" onClick={onToggle}>☰</button>
        <h1 className="page-title">{title}</h1>
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
        <div className="user-area">
          <div className="user-info">
            <div className="user-name">{user?.name || "Officer"}</div>
            <div className="user-role">{user?.role || ""}</div>
          </div>
          <div className="user-avatar">
            {user?.name ? user.name[0] : "A"}
          </div>
        </div>
        <div style={{ height: "20px", width: "1px", background: "#ddd" }}></div>
        <button className="btn" onClick={onLogout} style={{ color: "#d32f2f", padding: "4px 8px" }}>
          Log Out
        </button>
      </div>
    </header>
  );
}

/* ------------------------- Pages ------------------------ */
function FilterSearchPage({ token, lists, filters, setFilters, onApply, onExport, rows, loading, isApplying, applyPercent, isExporting, exportPercent }) {
  return (
    <div>
      <div className="card" style={{ marginBottom: "20px" }}>
        <h2>Filter Criteria</h2>
        <Filters
          lists={lists}
          filters={filters}
          setFilters={setFilters}
          onApply={onApply}
          onExport={onExport}
          isApplying={isApplying}
          applyPercent={applyPercent}
          isExporting={isExporting} 
          exportPercent={exportPercent} 
        />
      </div>

      <div className="card" style={{ padding: "0" }}>
          {/* Table container handled inside ResultsTable usually, but ensure wrapper here if needed */}
          <div style={{ padding: "15px", borderBottom: "1px solid #eee", display:"flex", justifyContent:"space-between" }}>
            <h3 style={{ margin:0, fontSize:"16px", color:"#094978" }}>Search Results</h3>
            <span style={{ fontSize:"12px", color:"#777"}}>Total Records: {rows.length}</span>
          </div>
          <div style={{ padding: "15px" }}>
            <ResultsTable rows={rows} />
          </div>
      </div>
    </div>
  );
}

function ReportsPageUI({ token }) {
  return <ReportsPage token={token} />;
}

/* ------------------------- Main App --------------------- */
export default function App() {
  const [token, setToken] = useState(localStorage.getItem("token"));
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("user") || "null"));
  
  // Changed default to Dashboard
  const [active, setActive] = useState("dashboard");
  
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [serverStatus, setServerStatus] = useState("unknown");
  const [checkingServer, setCheckingServer] = useState(false);

  const [lists, setLists] = useState({});
  const [filters, setFilters] = useState({
    finance_year: "ALL", from_year: "ALL", to_year: "ALL", month_year: "ALL",
    state: "ALL", university: "ALL", category: "ALL", handicaped: "ALL",
    gender: "ALL", scheme: "ALL", stream: "ALL", subject: "ALL", period: "ALL",
    student_id: "", student_name: "", q: "",
  });

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  
  // Progress States for Buttons
  const [isApplying, setIsApplying] = useState(false);
  const [applyPercent, setApplyPercent] = useState(0);
  const [isExporting, setIsExporting] = useState(false);
  const [exportPercent, setExportPercent] = useState(0);

  // New Progress States for Initial Fetch (Green Bar)
  const [listLoading, setListLoading] = useState(false);
  const [listLoadingPercent, setListLoadingPercent] = useState(0);

  // Animation: Green Bar (Initial List Fetch)
  useEffect(() => {
    let timer;
    if (listLoading) {
      setListLoadingPercent(0);
      timer = setInterval(() => {
          setListLoadingPercent((prev) => (prev >= 95 ? prev : prev + 10));
      }, 100);
    } else {
      setListLoadingPercent(100);
      setTimeout(() => setListLoadingPercent(0), 500);
    }
    return () => clearInterval(timer);
  }, [listLoading]);

  // ✅ Fixed: Wrapped in useCallback to prevent useEffect warning
  const checkServer = useCallback(async () => {
    try {
      setCheckingServer(true);
      const res = await fetchJSON(`${API}/api/health`);
      setCheckingServer(false);
      setServerStatus(res.ok ? "online" : "offline");
    } catch (e) {
      console.error(e);
      setCheckingServer(false);
      setServerStatus("offline");
    }
  }, []);

  // ✅ Fixed: Included loadLists in dependency array
  const loadLists = useCallback(async (tok) => {
    setListLoading(true); // START ANIMATION
    try {
      // Uses the passed token OR the state token
      const res = await fetchJSON(`${API}/api/pms/lists`, { headers: { Authorization: `Bearer ${tok || token}` } });
      if (res.ok) {
        setLists(res.data);
        setServerStatus("online");
      } else {
        if (res.status === 504) setServerStatus("offline");
      }
    } catch (e) {
      setServerStatus("offline");
    } finally {
        setListLoading(false); // STOP ANIMATION
    }
  }, [token]);

  useEffect(() => { checkServer(); }, [checkServer]);
  
  // ✅ Fixed: Included loadLists in dependency array
  useEffect(() => { if (token) loadLists(); }, [token, loadLists]);

  // --- LOGOUT FUNCTION (Memoized for Session Expiry) ---
  const logout = useCallback(() => {
    setToken(null);
    setUser(null);
    localStorage.clear();
    setRows([]);
    setActive("dashboard"); // Reset active tab on logout
  }, []);

  // --- AUTO LOGOUT LISTENER ---
  useEffect(() => {
    const handleSessionExpiry = () => {
      alert("Session is expired. Please re-login.");
      logout();
    };

    // Listen for custom event from fetchJSON
    window.addEventListener("auth:session-expired", handleSessionExpiry);

    return () => {
      window.removeEventListener("auth:session-expired", handleSessionExpiry);
    };
  }, [logout]);


  const onLogin = (tok, u) => {
    setToken(tok);
    setUser(u);
    localStorage.setItem("token", tok);
    localStorage.setItem("user", JSON.stringify(u));
    checkServer();
    loadLists(tok);
  };

  const apply = async () => {
    let timer;
    const startTime = Date.now();
    try {
      setIsApplying(true);
      setApplyPercent(1);
      setLoading(true);
      // Artificial start
      await new Promise((r) => setTimeout(r, 50));
      // Simulate progress
      timer = setInterval(() => {
        setApplyPercent((p) => (p >= 90 ? p : p + 5));
      }, 200);

      const r = await fetchJSON(`${API}/api/pms/filter`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify(filters),
      });

      if (!r.ok) {
        if (r.status === 504) setServerStatus("offline");
        throw new Error(r.data?.error || "Filter failed");
      }
      setServerStatus("online");
      setRows(r.data.rows);
    } catch (e) {
      alert("Filter failed. Please try again.");
    } finally {
      clearInterval(timer);
      const elapsed = Date.now() - startTime;
      const remaining = Math.max(1200 - elapsed, 0); // Ensure at least 1.2s visibility
      setTimeout(() => {
        setApplyPercent(100);
        setTimeout(() => {
          setIsApplying(false);
          setApplyPercent(0);
          setLoading(false);
        }, 300);
      }, remaining);
    }
  };

  const exportExcel = async () => {
    let timer;
    const startTime = Date.now();
    try {
      setIsExporting(true);
      setExportPercent(1);
      
      // Simulate download progress
      timer = setInterval(() => {
        setExportPercent((p) => (p >= 90 ? p : p + 4)); // Slightly slower than apply
      }, 300);

      const res = await fetch(`${API}/api/pms/export`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify(filters),
      });

      if (!res.ok) {
        // Handle Session Expiry for direct fetch calls too
        if(res.status === 401) {
             window.dispatchEvent(new CustomEvent("auth:session-expired"));
             throw new Error("Session expired");
        }
        throw new Error("Export failed");
      }
      
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `pms_export_${Date.now()}.xlsx`;
      a.click();
      window.URL.revokeObjectURL(url);

    } catch (e) {
      if(e.message !== "Session expired") {
         alert("Export failed: " + e.message);
      }
    } finally {
      clearInterval(timer);
      const elapsed = Date.now() - startTime;
      // Ensure the user sees the 100% bar for a moment
      setTimeout(() => {
        setExportPercent(100);
        setTimeout(() => {
            setIsExporting(false);
            setExportPercent(0);
        }, 500);
      }, Math.max(800 - elapsed, 0));
    }
  };

  // Helper to determine the topbar title
  const getPageTitle = () => {
    switch(active) {
      case "dashboard": return "Dashboard"; // Added Title
      case "filter_search": return "Filter & Search";
      case "reports": return "Reports";
      case "master_report": return "Master Report"; 
      case "users": return "User Management";
      case "settings": return "System Configuration";
      default: return "PMS Portal";
    }
  };

  if (!token) return <Login onLogin={onLogin} serverStatus={serverStatus} checkingServer={checkingServer} />;

  return (
    <div className={`app-root ${sidebarCollapsed ? "collapsed-mode" : ""}`}>
      {/* 1. GOV STRIP (Top of everything) */}
      <div className="gov-strip">
          <span>NATIONAL SCHEDULED CASTES FINANCE AND DEVELOPMENT CORPORATION</span>
          <span>MINISTRY OF SOCIAL JUSTICE AND EMPOWERMENT</span>
      </div>

      <div className="app-body">
        <Sidebar
          collapsed={sidebarCollapsed}
          setCollapsed={setSidebarCollapsed}
          active={active}
          setActive={setActive}
          serverStatus={serverStatus}
        />

        <div className="main">
          <Topbar
            title={getPageTitle()} 
            user={user}
            onLogout={logout}
            onToggle={() => setSidebarCollapsed((s) => !s)}
          />

          <main className="content">
            
            {/* --- GLOBAL LOADING BAR FOR LISTS --- */}
            {/* GREEN BAR: INITIAL LIST LOADING */}
            <div style={{ 
                height: listLoadingPercent > 0 ? '4px' : '0px', 
                background: '#e0e0e0', 
                transition: 'height 0.2s', 
                overflow: 'hidden', 
                marginBottom: listLoadingPercent > 0 ? 10 : 0 
            }}>
                <div style={{ 
                    width: `${listLoadingPercent}%`, 
                    height: '100%', 
                    background: '#28a745', 
                    transition: 'width 0.2s ease' 
                }} />
            </div>
            
            {listLoading && (
                <div style={{
                    fontSize: '12px', 
                    color: '#28a745', 
                    marginBottom: 10, 
                    textAlign: 'center',
                    fontWeight: 600
                }}>
                    Fetching data from Database...
                </div>
            )}
            {/* ------------------------------------ */}

            {/* --- NEW: Dashboard Component Render --- */}
            {active === "dashboard" && <Dashboard token={token} />}

            {active === "filter_search" && (
              <FilterSearchPage
                token={token}
                lists={lists}
                filters={filters}
                setFilters={setFilters}
                onApply={apply}
                onExport={exportExcel}
                rows={rows}
                loading={loading}
                isApplying={isApplying}
                applyPercent={applyPercent}
                isExporting={isExporting} // Passing new export state
                exportPercent={exportPercent} // Passing new export percent
              />
            )}
            {active === "reports" && <ReportsPageUI token={token} />}
            {/* --- Master Report Component Render --- */}
            {active === "master_report" && <MasterReport token={token} />} 
            
            {active === "users" && <div className="card"><h2>User Management</h2><p className="muted">Administrative access only.</p></div>}
            {active === "settings" && <div className="card"><h2>Configuration</h2><p className="muted">System parameters.</p></div>}
          </main>
        </div>
      </div>
    </div>
  );
}